import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import useMarket from 'hook/useMarket'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { options } from 'components/Home/components/LeftHomeComponents/MarketReview1Config'

export default function MarketReview1Modal() {
  const [filter, setFilter] = useState({ time: '6M' })
  const CommnonStore = useSelector((state: any) => state?.CommnonStore)
  const MarketStore = useSelector((state: any) => state?.MarketStore)
  const { fetchVietnam, filterVietname } = useMarket();

  let height = 250;
  let fontSizeLabel = '14px'
  if (CommnonStore?.innerWidthScreen < 1440 && CommnonStore?.innerWidthScreen > 700) {
    height = 250
  } else if (CommnonStore?.innerWidthScreen < 700) {
    height = 200;
    fontSizeLabel = '10px'
  }

  useEffect(() => {
    fetchVietnam({ time: filter.time })
  }, [filter])

  return (
    <>
      <div className='xlwouocrlq'>
        <div className='czmxzggkie'>Định giá các thị trường</div>
      </div>
      <div className='ozbfgukqye'>
        <div className='awwxanjhdo' style={{ marginBottom: 0 }}>
          <div className='fskaneywbs'>
          </div>
          <div className='gxrkqvwmpi'>
            Định giá (P/E) TTCK Việt Nam
          </div>
        </div>
        <div className='awwxanjhdo'>
          <div className='fskaneywbs'>
            <div onClick={() => setFilter({ time: '6M' })} className={`bifgkqkhej ${filter?.time === '6M' ? 'mrpddsvjim' : ''}`}>6M</div>
            <div onClick={() => setFilter({ time: '1Y' })} className={`bifgkqkhej ${filter?.time === '1Y' ? 'mrpddsvjim' : ''}`}>1Y</div>
            <div onClick={() => setFilter({ time: '2Y' })} className={`bifgkqkhej ${filter?.time === '2Y' ? 'mrpddsvjim' : ''}`}>2Y</div>
          </div>
          <div className='gxrkqvwmpi'>
          </div>
        </div>
        <div className='rvwpnmqluj'>
          <HighchartsReact
            highcharts={Highcharts}
            options={options(filterVietname(MarketStore?.marketVietnam || []), filter.time, height, fontSizeLabel)}
          />
          <div className="laAwQBVfKg">
            VN  Index
          </div>
          <div className="BMSsrhECYA">
            P/E
          </div>
        </div>
      </div>
    </>
  )
}